import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import "./ChatContact.scss";
import { formatImageUrl } from "@/common/utils";
import { fromNow } from "@/common/dateUtils";
import { FHTMessageType } from "@/models/MessageTypes";
import { FhtLeancloudCustomMessageType } from "@/common/types";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";
export default function ChatContact(props) {
  var contact = props.contact,
      lastMessage = props.lastMessage,
      handleCloseContactTab = props.handleCloseContactTab;
  var info = contact.getContactInfo();
  var unreadMessageCountInfo = null;
  var count = contact.unreadMessageCount;
  var avatarUrl = formatImageUrl(info.avatarUrl, ImageSizeTypeEnum.Thumbnail44whFill);

  var lastMsg = function lastMsg(last) {
    switch (last.messageType) {
      case FHTMessageType.RichCustomMessage:
        var cm = props.lastMessage;

        switch (cm.customType) {
          case FhtLeancloudCustomMessageType.BusinessEmoji:
            return "[商务表情]";

          case FhtLeancloudCustomMessageType.TopicPost:
            return "[服务信息]";

          case FhtLeancloudCustomMessageType.Product:
            return "[产品信息]";

          case FhtLeancloudCustomMessageType.NameCard:
            return "[个人名片]";

          case FhtLeancloudCustomMessageType.CompanyCard:
            return "[企业名片]";

          case FhtLeancloudCustomMessageType.Forward:
            return "[聊天记录]";

          case FhtLeancloudCustomMessageType.Meetup:
            return "[一起玩]";

          case FhtLeancloudCustomMessageType.ChatRoomStatus:
            return "[系统消息]";

          case FhtLeancloudCustomMessageType.DataSync:
            return "";

          default:
            return last.getExcerptText();
        }

      default:
        return last.getExcerptText();
    }
  };

  if (count) {
    unreadMessageCountInfo = _jsx("span", __assign({
      className: "chat-contact__notification-num"
    }, {
      children: count > 99 ? 99 + "+" : count
    }), void 0);
  }

  return _jsxs(React.Fragment, {
    children: [_jsx("a", __assign({
      href: info.linkUrl,
      target: "_blank"
    }, {
      children: _jsx("img", {
        className: "chat-contact__avatar",
        src: avatarUrl
      }, void 0)
    }), void 0), unreadMessageCountInfo, _jsx("span", {
      className: "icon chat-contact__item-close-button",
      onClick: function onClick(e) {
        console.log("i am closing");
        e.preventDefault();
        e.stopPropagation();
        handleCloseContactTab(contact);
      }
    }, void 0), _jsxs("div", __assign({
      className: "chat-contact__right"
    }, {
      children: [_jsxs("p", {
        children: [_jsx("a", __assign({
          href: info.linkUrl,
          target: "_blank",
          className: "chat-contact__item-name"
        }, {
          children: info.name
        }), void 0), _jsx("span", __assign({
          className: "chat-contact__item-date"
        }, {
          children: lastMessage && fromNow(lastMessage.timestamp)
        }), void 0)]
      }, void 0), _jsx("p", __assign({
        className: "chat-contact__item-message"
      }, {
        children: lastMessage && lastMsg(lastMessage)
      }), void 0)]
    }), void 0)]
  }, void 0);
}